module.exports = __webpack_public_path__ + "img/octopus-deploy.761e514a.svg";